"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SABRE_DELETE_IMAGE = void 0;
var client_1 = require("@apollo/client");
exports.SABRE_DELETE_IMAGE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation DeleteImage($input: DeleteImageInput!) {\n    deleteImage(input: $input) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteImage($input: DeleteImageInput!) {\n    deleteImage(input: $input) {\n      deleted\n    }\n  }\n"])));
var templateObject_1;
